import { Loaders } from "../common/store/loaders/loaders.enum";

export const SEC_STACK_NO_GENERATE_PROMPT = `We are a managed IT services provider and are building out our security stack against best practices. We have identified a technology or practice that we do not have a solution for right now and need to explain this. 
Provide a short, professional and constructive answer explaining that we do not use the following technology or security practice but that we will assess the market over the coming months so we can provide the benefits that this technology / security practice will provide to our clients. 
The response should be written from the perspective of us as an MSP and our service delivery to clients, and indicate the benefits and value that we and our clients will get when we add this to our security stack. 
Don't add Best regards section at all! Don't start reponse such as "As a manged IT service provider", you don't need to mention who you are.
For context, an example of a technology would be endpoint protection, email filtering or web content filtering software / services, whereas an example of a practice (something you do or configure) would be penetration testing, setting up spf/skim/dmarc or configuring ntfs or rbac permissions. 
[ToolType]: [ToolName]`

export const SEC_STACK_GOV_RES_PROMPT =`You are a senior engineer in a Managed IT Services Company. I am going to ask you questions about your cyber security stack – specifically about your offerings and capabilities for cybersecurity and information security governance, risk and compliance (GRC). 

Your task is to provide a short answer to these questions (no longer than 1 paragraph).`

export const SEC_STACK_GOV_RES_YES_PROMPT = `Answer this question in a short, positive and professional manner where your answer indicates that you do have an offering in this area: 

Question: [Question]`;

export const SEC_STACK_GOV_RES_NO_PROMPT = `Answer this question in a short, professional and constructive manner, where the answer indicates that you do not have an offering in this area: 

Question: [Question]`;

export const SEC_STACK_GOV_RES_UNDER_REVIEW_PROMPT = `Answer this question in a short, professional and constructive manner, where the answer indicates that you do not have an offering in this area but are actively reviewing this so you will have an offering soon: 

Question: [Question]`;

export const SEC_STACK_GOV_RES_PARTNER_PROMPT = `Answer this question in a short, positive and professional manner, where the answer indicates that you work with a partner who specialises in this area to be able to provide this service to your clients: 

Question: [Question]`;

export const SecurityStackSidebarItems = {
  Toolset: "Toolset",
  Governance: "Governance",
}

export const SecurityStackSidebarLoaders = {
  [SecurityStackSidebarItems.Toolset]: [
    Loaders.GetSecurityStackViewLoader,
  ],
  [SecurityStackSidebarItems.Governance]: [
    Loaders.GetSecurityStackGRLoader,
  ],
}

export const SecurityStackLoaders = [
  ...Object.values(SecurityStackSidebarLoaders),
]